export default "__VITE_ASSET__BopLJLq___"